import { Box, BoxProps } from "@chakra-ui/react";
import Markdoc, { Config } from "@markdoc/markdoc";
import React, { useMemo } from "react";
import { markdocConfig } from "./markdocConfig";
import { CopyableInlineCode } from "./nodes/CopyableInlineCode";
import { MarkdocLink } from "./nodes/MarkdocLink";

export type MarkdocContentProps = {
  content: string;
  config?: Config;
  variables?: Config["variables"];
  components?: Record<string, React.ElementType>;
} & BoxProps;

export function MarkdocContent({
  content,
  config,
  variables,
  components,
  ...props
}: MarkdocContentProps) {
  const rendered = useMemo(() => {
    const ast = Markdoc.parse(content);
    const transformed = Markdoc.transform(ast, {
      ...markdocConfig,
      ...config,
      nodes: {
        ...markdocConfig.nodes,
        ...config?.nodes,
      },
      tags: {
        ...markdocConfig.tags,
        ...config?.tags,
      },
      variables,
    });

    return Markdoc.renderers.react(transformed, React, {
      components: {
        ...baseComponents,
        ...components,
      },
    });
  }, [config, content, variables, components]);

  return (
    <Box textStyle="richContent" {...props}>
      {rendered}
    </Box>
  );
}

const baseComponents = {
  MarkdocLink,
  CopyableInlineCode,
};
